import { TICKETS_ID, TIMESLOT_ID,GAME_START_BOOKING_KEY } from '../../constants';
import {
  CHECKOUT_BASKET_CLEAR,
  CHECKOUT_BROWSER_PAYMENT_SELECT,
  CHECKOUT_CARD_SELECT,
  CHECKOUT_ORDER_MADE,
  CHECKOUT_PAYMENT_TYPE_SELECT,
  CHECKOUT_STORE_SELECT,
  CHECKOUT_TICKET_SET,
  CHECKOUT_TIMESLOT_SELECT
} from './types';

// Get preselected items from params if page reload
let tickets = 1;
let timeslotId = null;
let bookingId = null;
if (typeof window !== `undefined`) {
  const queryParams = new URLSearchParams(window.location.search);
  const ticketsInParams = +queryParams.get(TICKETS_ID);
  if (ticketsInParams && Number.isInteger(ticketsInParams)) {
    tickets = ticketsInParams;
  }
  timeslotId = queryParams.get(TIMESLOT_ID) || null;
  bookingId = queryParams.get(GAME_START_BOOKING_KEY) || null;
  let url = window.location.pathname.split("/");
  let gameId = url[2];

}
const initialState = {
  paymentType: null,
  paymentId: null,
  tickets,
  timeslotId,
  timeslot:null,
  bookingId
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECKOUT_PAYMENT_TYPE_SELECT: {
      return {
        ...state,
        paymentType: action.paymentType,
        paymentId: null
      };
    }
    case CHECKOUT_CARD_SELECT: {
      return {
        ...state,
        paymentType: 'card',
        paymentId: action.paymentCardId
      };
    }
    case CHECKOUT_STORE_SELECT: {
      return {
        ...state,
        paymentType: 'konbini',
        paymentId: action.store
      };
    }
    case CHECKOUT_BROWSER_PAYMENT_SELECT: {
      return {
        ...state,
        paymentType: 'browser'
      };
    }
    case CHECKOUT_TIMESLOT_SELECT: {
      return {
        ...state,
        timeslotId: action.timeslot.key,
        timeslot: action.timeslot.value
      };
    }
    case CHECKOUT_TICKET_SET: {
      return {
        ...state,
        tickets: action.tickets
      };
    }
    case CHECKOUT_ORDER_MADE: {
      return {
        ...state
      };
    }
    case CHECKOUT_BASKET_CLEAR: {
      return {
        ...initialState
      };
    }
    default:
      return state;
  }
};
